import { useMutation, useQueryClient } from "@tanstack/react-query";

import { type SetActualDatesInput, setStageActualDates } from "@/adapters/api";

export function useSetActualDates(constructionId: string | undefined) {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: ({
			stageId,
			input,
		}: {
			stageId: string;
			input: SetActualDatesInput;
		}) => {
			if (!constructionId) throw new Error("missing construction");
			return setStageActualDates(constructionId, stageId, input);
		},
		onSuccess: (_schedule, { stageId }) => {
			queryClient.invalidateQueries({
				queryKey: ["schedules", constructionId],
			});
			queryClient.invalidateQueries({
				queryKey: ["schedule", constructionId, stageId],
			});
		},
	});
}
